import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { resource } from "../../utility/constants/resource/resource";

const SideNavBar = ({
	onClick,
	options,
	setOptions,
}: {
	onClick?: (name: string) => void;
	options?: any[];
	setOptions?: (item: any) => void;
}) => {
	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "center",
				//border: `0.5px solid ${resource.colors.borderOutlineColor}`,
				height: "100%",
				".MuiButton-root": {
					textTransform: "none",
					//borderTop: `0.5px solid ${resource.colors.borderOutlineColor}`,
					borderRadius: 0,
				},
				borderRadius: "6px",
			}}
		>
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					width: "100%",
					margin: 3,
					textAlign: "left",
				}}
			>
				{options?.map(({ name, label, style }, index) => (
					<Button
						key={name ?? `btn${index}`}
						onClick={() => onClick?.(name)}
						sx={{
							...style,
							justifyContent: "flex-start",
							textAlign: "left",
						}}
					>
						{label}
					</Button>
				))}
			</Box>
		</Box>
	);
};
export default SideNavBar;
